import template from './access-roles.html';

class ProfileAccessRolesTabComponentVM
{
	constructor(params)
	{
		this.vm = params.vm;
		this.show_advanced_roles = ko.observable(false);

		this.allGroupNames = ko.observableArray();
		this.availableGroupNames = ko.observableArray();
		this.selectedAvailableGroupNames = ko.observableArray();
		this.selectedCurrentGroupNames = ko.observableArray();
		this.currentGroupNames = ko.observableArray([]);

		this.allAdvancedRoleNames = ko.observableArray();
		this.availableAdvancedRoleNames = ko.observableArray();
		this.selectedAvailableAdvancedRoleNames = ko.observableArray();
		this.selectedCurrentAdvancedRoleNames = ko.observableArray();
		this.currentAdvancedRoleNames = ko.observableArray([]);

		this.roleTypeMap = {};
		this.roleDisplayNameMap = {};
		this.groupMembershipMap = {};

		this.vm.register_tab_state('roles', this);
		this.vm.user_data.subscribe((user) => {
			this.load_from_user(user);
		});
		if (this.vm.user_data())
			this.load_from_user(this.vm.user_data());

		this.init();
		this.currentGroupNames.subscribe(() => this.updateAvailableRoles());
		this.currentAdvancedRoleNames.subscribe(() => this.updateAvailableRoles());

		this.availableAdvancedRoleOptions = ko.pureComputed(() =>
			(this.availableAdvancedRoleNames() || []).map((roleName) => ({
				role_name: roleName,
				display_name: this.get_role_display_name(roleName)
			}))
		);

		this.currentAdvancedRoleOptions = ko.pureComputed(() =>
			this.get_effective_advanced_role_names().map((roleName) => ({
				role_name: roleName,
				display_name: this.get_role_display_name(roleName)
			}))
		);
	}

	group_checked_state (groupName)
	{
		return ko.computed({
			read: () => (this.currentGroupNames() || []).indexOf(groupName) >= 0,
			write: (val) => {
				let cur = (this.currentGroupNames() || []).slice();
				if (val) { if (cur.indexOf(groupName) < 0) cur.push(groupName); }
				else cur = cur.filter((n) => n !== groupName);
				this.currentGroupNames(cur);
			},
			owner: this
		});
	}

	get_role_display_name (roleName)
	{
		return this.roleDisplayNameMap[roleName] || roleName;
	}

	async init ()
	{
		const accessRoles = await Grape.cache.fetch('AccessRoles');
		const groups = [];
		const advancedRoles = [];
		this.roleTypeMap = {};
		this.roleDisplayNameMap = {};
		this.groupMembershipMap = {};

		for (const role of (accessRoles || []))
		{
			this.roleTypeMap[role.role_name] = role.role_type;
			this.roleDisplayNameMap[role.role_name] = role.display_name || role.role_name;
			if (role.role_type == 'GROUP')
			{
				groups.push(role.role_name);
				this.groupMembershipMap[role.role_name] = role.membership || [];
			}
			else
				advancedRoles.push(role.role_name);
		}

		this.allGroupNames(groups.sort((a, b) => this.get_role_display_name(a).localeCompare(this.get_role_display_name(b))));
		this.allAdvancedRoleNames(advancedRoles.sort());
		this.updateAvailableRoles();
		if (this.vm.user_data())
			this.load_from_user(this.vm.user_data());
	}

	updateAvailableRoles ()
	{
		const currentGroups = this.currentGroupNames() || [];
		const allGroups = this.allGroupNames() || [];
		this.availableGroupNames(allGroups.filter((roleName) => currentGroups.indexOf(roleName) < 0));

		const currentAdvancedRoles = this.get_effective_advanced_role_names();
		const allAdvancedRoles = this.allAdvancedRoleNames() || [];
		this.availableAdvancedRoleNames(allAdvancedRoles.filter((roleName) => currentAdvancedRoles.indexOf(roleName) < 0));
	}

	get_group_inherited_advanced_role_names ()
	{
		const inherited = new Set();
		for (const groupName of (this.currentGroupNames() || []))
		{
			const membership = this.groupMembershipMap[groupName] || [];
			for (const roleName of membership)
			{
				if (this.roleTypeMap[roleName] == 'GROUP')
					continue;
				inherited.add(roleName);
			}
		}
		return Array.from(inherited);
	}

	get_effective_advanced_role_names ()
	{
		return [...new Set([
			...(this.currentAdvancedRoleNames() || []),
			...this.get_group_inherited_advanced_role_names()
		])];
	}

	is_inherited_advanced_role (roleName)
	{
		return (this.currentAdvancedRoleNames() || []).indexOf(roleName) < 0
			&& this.get_group_inherited_advanced_role_names().indexOf(roleName) >= 0;
	}

	load_from_user (user)
	{
		const userRoles = user?.assigned_role_names || user?.user_roles || [];
		const currentGroups = [];
		const currentAdvancedRoles = [];
		for (const roleName of userRoles)
		{
			if (this.roleTypeMap[roleName] == 'GROUP')
				currentGroups.push(roleName);
			else
				currentAdvancedRoles.push(roleName);
		}
		this.currentGroupNames(currentGroups);
		this.currentAdvancedRoleNames(currentAdvancedRoles);
		this.updateAvailableRoles();
	}

	btnRemoveGroups_click ()
	{
		let currentGroups = this.currentGroupNames();
		const groupsToRemove = this.selectedCurrentGroupNames();
		currentGroups = currentGroups.filter((roleName) => !groupsToRemove.includes(roleName));
		this.currentGroupNames(currentGroups);
		this.selectedCurrentGroupNames([]);
	}

	btnAddGroups_click ()
	{
		let currentGroups = this.currentGroupNames();
		if (!currentGroups)
			currentGroups = [];
		this.currentGroupNames(currentGroups.concat(this.selectedAvailableGroupNames()));
		this.selectedAvailableGroupNames([]);
	}

	btnRemoveAdvancedRoles_click ()
	{
		let currentAdvancedRoles = this.currentAdvancedRoleNames();
		const rolesToRemove = this.selectedCurrentAdvancedRoleNames();
		currentAdvancedRoles = currentAdvancedRoles.filter((roleName) => !rolesToRemove.includes(roleName));
		this.currentAdvancedRoleNames(currentAdvancedRoles);

		this.selectedCurrentAdvancedRoleNames(
			(rolesToRemove || []).filter((roleName) => this.is_inherited_advanced_role(roleName))
		);
	}

	btnAddAdvancedRoles_click ()
	{
		let currentAdvancedRoles = this.currentAdvancedRoleNames();
		if (!currentAdvancedRoles)
			currentAdvancedRoles = [];
		this.currentAdvancedRoleNames(currentAdvancedRoles.concat(this.selectedAvailableAdvancedRoleNames()));
		this.selectedAvailableAdvancedRoleNames([]);
	}

	get_save_data ()
	{
		const role_names = []
			.concat(this.currentGroupNames() || [])
			.concat(this.currentAdvancedRoleNames() || []);

		return {
			role_names: [...new Set(role_names)]
		};
	}
}

export default {
	name: 'profile-access-roles-tab',
	viewModel: ProfileAccessRolesTabComponentVM,
	module_type: 'ko',
	template: template
};
